import { StreamPlatforms, StreamPlatformsUrl } from ".";

export const StreamUrls: Record<StreamPlatforms, StreamPlatformsUrl> = {
  [StreamPlatforms.Twitch]: StreamPlatformsUrl.Twitch,
  [StreamPlatforms.Kick]: StreamPlatformsUrl.Kick,
};
